var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTips({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95841 4.75C3.52119 4.75 3.16675 5.10444 3.16675 5.54167V10.2917C3.16675 13.3522 5.64784 15.8333 8.70841 15.8333H10.2917C13.0835 15.8333 15.3932 13.7689 15.7773 11.0833H15.8334C17.5823 11.0833 19.0001 9.66557 19.0001 7.91667C19.0001 6.16777 17.5823 4.75 15.8334 4.75H3.95841ZM15.8334 6.33333V9.5C16.7079 9.5 17.4167 8.79112 17.4167 7.91667C17.4167 7.04222 16.7079 6.33333 15.8334 6.33333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12492 2.37499C7.12492 1.93777 6.77048 1.58333 6.33325 1.58333C5.89603 1.58333 5.54159 1.93777 5.54159 2.37499V4.74999H7.12492V2.37499ZM10.2916 2.37499C10.2916 1.93777 9.93714 1.58333 9.49992 1.58333C9.06269 1.58333 8.70825 1.93777 8.70825 2.37499V4.74999H10.2916V2.37499ZM12.6666 1.58333C13.1038 1.58333 13.4583 1.93777 13.4583 2.37499V4.74999H11.8749V2.37499C11.8749 1.93777 12.2294 1.58333 12.6666 1.58333ZM4.74992 15.8333C4.31269 15.8333 3.95825 16.1878 3.95825 16.625C3.95825 17.0622 4.31269 17.4167 4.74992 17.4167H14.2499C14.6871 17.4167 15.0416 17.0622 15.0416 16.625C15.0416 16.1878 14.6871 15.8333 14.2499 15.8333H4.74992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.2464f515965fd94c3662460176a848ef.svg";
export { ForwardRef as ReactComponent };